"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistryService = void 0;
const contracts_1 = require("../contracts");
const service_1 = require("../service");
class RegistryService extends service_1.Service {
    constructor(sdk) {
        super(sdk);
        this.entries = {};
        this.registry = contracts_1.Registry__factory.connect('0xFda7eB6f8b7a9e9fCFd348042ae675d1d652454f', this.provider);
    }
    async get(key) {
        if (!this.entries[key]) {
            try {
                this.entries[key] = await this.registry.get(key);
            }
            catch (err) {
                console.error(`Failed to get ${key}`, err);
            }
        }
        return this.entries[key];
    }
    async getProductionVaults() {
        return this.registry.getProductionVaults();
    }
}
exports.RegistryService = RegistryService;
//# sourceMappingURL=registry.service.js.map